export const CONTEST_RETURN_URL_KEY = "contestReturnUrl";

export const getContestReturnUrl = () => {
  const savedUrl = sessionStorage.getItem(CONTEST_RETURN_URL_KEY);
  return savedUrl || "/dash/contest";
};

export const saveContestReturnUrl = (url) => {
  sessionStorage.setItem(CONTEST_RETURN_URL_KEY, url || "/dash/contest");
};
